import { connect } from 'react-redux'
import App from './App'

const updateCitations = (citations, style) => (
  (dispatch, getState, { wordApi }) => {
    wordApi.updateCitations(citations, style)
  }
)

const mapStateToProps = (state) => ({
  isLoading: state.loading.length > 0,
  citations: state.citations,
  page: state.page,
  style: state.currentProject.defaultstyle,
})

const mapDispatchToProps = (dispatch) => ({
  handleUpdateCitations: (citation, style) => {
    dispatch(updateCitations(citation, style))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/AppContainer.js